import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};


export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,816.000000) scale(0.100000,-0.100000)" >
<path d="M5277 8623 c-4 -3 -7 -144 -7 -312 l0 -306 -223 -167 c-374 -280
-1088 -817 -1168 -879 l-75 -59 -345 -2 -344 -3 0 -350 0 -350 355 -5 355 -5
365 -275 c201 -151 478 -359 615 -463 138 -104 296 -223 352 -266 l103 -76 0
-272 c0 -149 -4 -273 -9 -275 -4 -1 -21 -13 -37 -25 -16 -13 -74 -57 -129 -98
-55 -42 -107 -81 -115 -88 -8 -7 -242 -183 -520 -392 -278 -209 -536 -403
-575 -432 l-70 -53 -348 0 -347 0 2 -352 3 -353 355 0 355 0 3 300 3 300 27
21 c15 11 200 150 412 309 212 159 387 292 390 295 3 3 147 112 320 242 l315
238 340 2 340 3 3 351 2 352 -22 6 c-13 3 -166 6 -341 6 l-318 0 -156 118
c-86 64 -214 160 -283 212 -70 52 -309 232 -531 400 -222 167 -425 320 -451
340 l-48 35 0 252 0 251 123 93 c67 51 374 281 682 513 308 231 562 423 565
426 3 3 28 22 56 43 l51 37 334 2 334 3 3 351 2 351 -47 7 c-65 8 -648 8 -656
-1z"/>
<path d="M4051 6900 c-13 -6 -41 -24 -62 -41 l-39 -31 0 -283 c0 -282 0 -284
22 -299 19 -14 77 -16 423 -16 443 -1 499 -6 627 -60 226 -93 388 -317 388
-535 0 -114 -58 -293 -120 -372 -11 -15 -17 -30 -12 -35 4 -4 167 -7 362 -6
l353 3 38 100 c142 380 87 726 -170 1070 -101 135 -162 186 -331 279 -190 105
-376 166 -627 207 -106 17 -187 21 -478 25 -224 3 -359 0 -374 -6z"/>
<path d="M3132 4823 l3 -1278 350 0 350 0 0 1275 0 1275 -353 3 -352 2 2
-1277z"/>
<path d="M3897 5183 c-4 -3 -7 -163 -7 -354 0 -307 2 -348 16 -353 20 -8 908
-8 928 0 14 5 16 46 16 354 0 308 -2 349 -16 354 -21 8 -929 8 -937 -1z"/>
<path d="M6035 5177 c-3 -6 -4 -167 -3 -357 l3 -345 302 -1 c166 -1 319 -5
339 -9 65 -12 148 -61 201 -118 103 -113 147 -260 122 -407 -6 -36 -12 -75
-13 -87 0 -13 -5 -23 -9 -23 -4 0 -14 -15 -22 -34 -17 -40 -76 -119 -113 -152
-28 -24 -81 -53 -147 -79 -35 -14 -170 -16 -1283 -15 l-1244 0 -84 -62 c-46
-34 -84 -66 -84 -70 0 -4 -5 -8 -10 -8 -19 0 -108 -75 -114 -95 -3 -11 -6
-133 -6 -270 0 -182 3 -254 12 -263 9 -9 333 -12 1398 -12 1464 0 1500 1 1650
46 332 99 631 447 715 834 32 150 37 208 32 370 -7 240 -46 396 -147 588 -147
282 -366 466 -638 538 -136 36 -235 44 -545 44 -238 0 -309 -3 -312 -13z"/>
<path d="M3138 2394 c-14 -13 -9 -54 7 -60 12 -5 15 -26 15 -105 0 -79 -3
-101 -15 -105 -9 -4 -15 -19 -15 -36 l0 -30 124 4 c108 3 128 6 153 24 37 28
45 95 14 128 -20 21 -20 24 -5 54 20 41 11 87 -23 109 -18 12 -55 18 -137 21
-61 2 -114 1 -118 -4z m179 -80 c8 -22 -9 -48 -36 -52 -18 -3 -21 1 -21 32 0
32 3 36 25 36 15 0 28 -7 32 -16z m-6 -114 c26 -14 25 -56 -2 -70 -33 -18 -49
-5 -49 40 0 43 12 50 51 30z"/>
<path d="M3450 2365 c0 -19 4 -35 9 -35 4 0 11 -41 14 -90 4 -50 14 -104 22
-120 29 -56 115 -82 183 -54 58 23 75 57 80 169 3 50 10 94 17 101 6 7 11 23
10 36 -2 22 -5 23 -71 23 -68 0 -69 0 -72 -28 -2 -18 2 -29 12 -33 12 -5 16
-22 16 -74 0 -88 -12 -120 -44 -120 -36 0 -47 22 -53 110 -5 70 -4 80 11 80
12 0 16 9 16 35 l0 35 -75 0 -75 0 0 -35z"/>
<path d="M3810 2365 c0 -19 5 -35 10 -35 6 0 10 -40 10 -99 0 -56 -4 -103 -10
-106 -5 -3 -10 -20 -10 -36 l0 -30 131 3 131 3 1 60 1 60 -37 3 c-34 3 -38 1
-43 -27 -6 -26 -11 -31 -35 -31 l-29 0 0 100 c0 82 3 100 15 100 10 0 15 11
15 35 l0 35 -75 0 -75 0 0 -35z"/>
<path d="M4087 2394 c-13 -14 -8 -64 7 -64 10 0 24 -40 46 -135 l32 -135 54 0
53 0 16 58 c32 113 29 112 50 24 l18 -82 57 0 57 0 32 123 c40 151 38 147 51
147 5 0 10 16 10 35 l0 35 -65 0 -65 0 0 -34 c0 -19 5 -36 11 -38 8 -3 7 -24
-3 -73 l-14 -70 -23 108 -24 107 -48 0 c-47 0 -48 -1 -58 -37 -6 -21 -15 -68
-22 -105 -7 -38 -15 -66 -17 -63 -3 3 -11 34 -17 70 -11 56 -10 65 2 65 10 0
13 9 11 33 l-3 32 -70 3 c-39 1 -74 0 -78 -4z"/>
<path d="M4649 2398 c-7 -13 -5 -56 3 -65 13 -16 -39 -182 -63 -205 -11 -9
-19 -28 -19 -42 0 -26 1 -26 75 -26 l75 0 0 30 c0 20 -5 30 -15 30 -8 0 -15 9
-15 20 0 17 7 20 50 20 28 0 50 -4 50 -10 0 -5 0 -13 0 -17 0 -5 -8 -8 -18 -8
-12 0 -17 -8 -17 -30 l0 -30 95 0 c83 0 95 2 98 18 2 10 -7 28 -20 40 -16 15
-35 60 -57 137 -19 63 -39 121 -44 128 -6 8 -38 12 -93 12 -46 0 -85 -1 -85
-2z m109 -138 c10 -42 7 -50 -21 -46 -19 2 -20 6 -11 54 8 43 19 40 32 -8z"/>
<path d="M5099 2389 c-3 -31 4 -54 17 -62 10 -6 14 -31 14 -97 0 -78 -2 -91
-19 -100 -13 -7 -19 -19 -18 -38 2 -27 4 -27 77 -30 108 -5 172 11 209 53 71
82 46 223 -48 263 -50 21 -231 30 -232 11z m177 -67 c39 -25 46 -124 13 -166
-12 -15 -30 -26 -45 -26 -24 0 -24 1 -24 100 0 97 1 100 23 100 12 0 27 -4 33
-8z"/>
<path d="M5507 2388 c-2 -7 0 -26 4 -42 11 -37 -34 -193 -62 -218 -11 -9 -19
-28 -19 -42 0 -26 1 -26 75 -26 l75 0 0 30 c0 20 -5 30 -15 30 -8 0 -15 9 -15
20 0 17 7 20 49 20 33 0 51 -5 54 -14 7 -17 -1 -26 -24 -26 -13 0 -17 -7 -16
-27 l2 -28 95 0 c90 0 95 1 98 22 2 14 -4 26 -16 32 -20 10 -29 34 -82 209
l-22 72 -88 0 c-62 0 -90 -4 -93 -12z m118 -168 c-2 -3 -14 -6 -27 -5 -24 2
-26 14 -6 64 l10 26 14 -39 c8 -21 12 -42 9 -46z"/>
<path d="M5830 2345 c0 -30 0 -58 0 -62 0 -5 15 -9 35 -11 33 -3 35 -2 35 27
0 24 4 31 20 31 19 0 20 -7 20 -99 0 -90 -2 -99 -20 -104 -15 -4 -20 -14 -20
-36 l0 -32 88 3 c86 3 87 3 90 29 2 20 -2 28 -17 32 -19 5 -21 13 -21 106 0
95 1 101 21 101 11 0 17 -5 14 -10 -3 -6 -3 -19 0 -31 5 -16 14 -19 38 -17
l32 3 0 60 0 60 -157 3 -158 3 0 -56z"/>
<path d="M6247 2394 c-10 -10 -9 -48 2 -59 14 -16 -49 -204 -71 -210 -12 -4
-18 -16 -18 -36 l0 -30 77 3 c75 3 76 3 77 30 1 18 -4 28 -16 31 -12 3 -16 11
-12 21 9 23 104 23 104 0 0 -9 -9 -18 -20 -21 -14 -4 -20 -14 -20 -34 l0 -29
95 0 95 0 0 29 c0 21 -6 32 -19 36 -11 3 -22 19 -26 35 -4 16 -21 76 -39 132
l-33 103 -85 3 c-46 1 -87 0 -91 -4z m108 -146 c7 -36 6 -38 -19 -38 -30 0
-30 1 -15 54 12 44 24 38 34 -16z"/>
<path d="M6731 2374 c-27 -22 -31 -32 -31 -74 0 -44 4 -52 33 -73 17 -13 52
-30 77 -37 78 -23 91 -50 24 -50 -23 0 -38 6 -46 20 -10 15 -24 20 -55 20
l-43 0 0 -60 0 -60 40 0 c27 0 43 5 46 15 5 11 10 13 19 5 45 -38 144 -29 183
15 27 32 29 84 5 114 -10 12 -49 34 -88 50 -52 21 -70 33 -70 47 0 32 41 30
72 -4 20 -20 37 -28 58 -28 30 1 30 2 33 64 l3 62 -41 0 c-34 0 -40 -3 -40
-21 l0 -20 -26 20 c-40 31 -113 29 -153 -5z"/>
<path d="M7020 2365 c0 -24 5 -35 15 -35 12 0 15 -16 15 -84 0 -96 7 -120 44
-157 52 -52 166 -44 210 14 17 23 22 46 24 128 3 79 7 99 19 99 10 0 13 9 11
33 l-3 32 -67 3 -68 3 0 -36 c0 -19 5 -35 10 -35 15 0 13 -163 -2 -178 -15
-15 -51 -15 -66 0 -15 15 -17 178 -2 178 6 0 10 16 10 35 l0 35 -75 0 -75 0 0
-35z"/>
<path d="M7380 2365 c0 -24 5 -35 15 -35 12 0 15 -18 15 -100 0 -80 -3 -102
-15 -106 -9 -4 -15 -19 -15 -35 l0 -29 103 0 c118 0 170 12 192 43 24 34 19
84 -11 114 -23 23 -24 27 -10 42 23 25 20 86 -5 109 -25 24 -69 32 -181 32
l-88 0 0 -35z m179 -52 c12 -23 -4 -53 -29 -53 -16 0 -20 7 -20 35 0 28 4 35
20 35 10 0 23 -8 29 -17z m-5 -113 c48 -18 26 -80 -28 -80 -12 0 -16 11 -16
45 0 48 4 51 44 35z"/>
</g>
</svg>

		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
